module.exports = __webpack_public_path__ + "static/gallery-3-5ff8b66211b6fd466df8a362222335e8.jpg";